import axios from '../Api/axios';
import useAuth from './useAuth';

const useLogout = () => {
    const { setAuth } = useAuth();
    const logout = async () => {
        setAuth({});
        try {
            const response = await axios('/logout',
                {
                    // send back req cookies
                    withCredentials: true
                });
            console.log(response);
        } catch (err) {
            console.error(err);
        }
    };
    // retyurn the hook to use it in several places
    return logout;
};

export default useLogout;